import {
  getPatientFindOneQueryKey,
  usePatientFindOneSuspense,
  usePatientUpdate,
} from '../../../libs/ohat-api';
import { Card, Col, Row } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { UpdatePatientDto } from '@models/updatePatientDto';
import { PatientForm } from './form/PatientForm';
import { CreatePatientDto } from '@models/createPatientDto';
import { useTranslation } from 'react-i18next';
import { PatientArchiveButton } from '../../components/PatientArchiveButton';

export function UpdatePatientPage() {
  const { t } = useTranslation();
  const param = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data } = usePatientFindOneSuspense(param.id ?? '');
  const { mutateAsync: updatePatient } = usePatientUpdate();

  // アーカイブ／解除後もこの画面に留まり、患者情報だけ再取得してボタン状態を更新する。
  const refetchPatient = () =>
    queryClient.invalidateQueries({
      queryKey: getPatientFindOneQueryKey(param.id!),
    });

  const onSubmit = async (values: CreatePatientDto | UpdatePatientDto) => {
    await updatePatient({ id: param.id!, data: values });
    navigate(`/patients/${param.id}`);
  };

  return (
    <Row gutter={[16, 8]} style={{ flex: 1, justifyContent: 'center' }}>
      <Col lg={8} md={12} sm={16} xs={24}>
        <Card
          title={t('patient.edit')}
          extra={
            <PatientArchiveButton
              patientId={param.id!}
              archived={!!data.archivedAt}
              onArchived={refetchPatient}
              onUnarchived={refetchPatient}
            />
          }
        >
          <PatientForm
            initialValue={data}
            onSubmit={onSubmit}
            onCancel={() => navigate(`/patients/${param.id}`)}
          />
        </Card>
      </Col>
    </Row>
  );
}
